import i18n from 'infrastructure/i18n';
import { DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';
import { Link } from 'react-router-dom';
import { Routes } from 'router/routes';
import { NORMAL_READINGS_REPORT_PER_PAGE } from 'infrastructure/hooks/normal-reading-report';

import s from './styles.module.scss';

import type { IBaseTableColumns } from 'components/atoms/base-table/types';
import type { INormalReadingsReport } from 'infrastructure/interfaces';

export const columns = (
  currentPage: number,
): IBaseTableColumns<INormalReadingsReport> => [
  {
    label: '№',
    key: 'guid',
    width: '50px',
    align: 'center',
    render: (_, record, idx) => {
      const itemIndexPrefix =
        (currentPage - 1) * NORMAL_READINGS_REPORT_PER_PAGE;

      return (
        <span data-cy="patientTable-number" className={s.number}>
          {itemIndexPrefix + idx + 1}
        </span>
      );
    },
  },
  {
    label: i18n.t('labels.patientGuid'),
    key: 'patientGuid',
    width: '280px',
    render: (guid: string) => (
      <Link to={`${Routes.patientGuid(guid)}`} className={s['guid-link']}>
        {guid}
      </Link>
    ),
  },
  {
    label: i18n.t('labels.patientName'),
    key: 'patientName',
    width: '270px',
  },
  {
    label: i18n.t('labels.clinicName'),
    key: 'clinicName',
    width: '300px',
  },
  {
    label: i18n.t('labels.lastInteraction'),
    key: 'lastInteractionDate',
    width: '140px',
    align: 'right',
    render: (date: string | null) =>
      date
        ? DateFormatter({ date, format: DateFormats['MM-dd-yyyy h:mm a'] })
        : i18n.t('labels.bannerNoData'),
  },
  {
    label: i18n.t('labels.normal'),
    key: 'normalReadingsCount',
    width: '70px',
    align: 'right',
  },
  {
    label: i18n.t('labels.atRisk'),
    key: 'riskReadingsCount',
    width: '70px',
    align: 'right',
  },
  {
    label: i18n.t('labels.totalReadings'),
    key: 'totalReadingsCount',
    width: '70px',
    align: 'right',
  },
];
